import {
    AppPlatform,
    Release,
    ReleaseStep,
    ReleaseStepFeatureReadinessData,
    ReleaseStepKickoffData,
    ReleaseStepType,
} from '../types';
import { RecursiveStringifyEnums } from './buildDistro';
import { syncFeatureAffiliationsDataWithFeatureStepData } from '@/testData/featureItems';

export const baseRelease = () => {
    const release: RecursiveStringifyEnums<Release> = {
        id: 'demo:1.0.0',
        releaseId: '1.0.0',
        rollbackInfo: {
            releaseId: '1.0.0',
            version: '1.0.0',
            status: 'active',
            isReadyToRelease: true,
        },
        workflowRunId: null,
        lifecycleAutomations: [],
        releasePilotId: 'demo@demo.co',
        version: '1.0.0',
        displayableVersion: '1.0.0',
        displayableNextVersion: '1.1.0',
        status: 'active',
        timelinePhase: 'current',
        type: 'minor',
        createdAt: '2022-03-02T01:15:47.588206559Z',
        updatedAt: '2022-03-03T18:04:31.32129177Z',
        targetKickoffDate: '2022-03-03T18:00:00Z',
        targetSubmitDate: '2022-03-23T17:00:00Z',
        phasedReleaseHasBeenSupersededByNewRelease: false,
        targetReleaseDate: '2022-03-25T17:00:00Z',
        stepRunGraph: {
            legacyReleaseId: '',
            stepGroups: [],
        },
        phasedRelease: null,
        doesBranchExist: true,
        releasedAt: null,
        createdOrigin: 'runwayDraft',
        isKickedOff: true,
        nextVersion: '3.98.0',
        scheduledAutomationsPaused: null,
        isReleaseTagged: false,
        isSubmitted: false,
        isReleased: false,
        overview: {
            totalAutomationsPerformedCount: 0,
            totalAutomationsScheduledCount: 0,
            estimatedAutomationsCostSaving: 0,
            estimatedAutomationsTimeSaved: 0,
            codeContributors: [],
            contributingTeams: [],
            topChangedFiles: [],
            totalFilesChanged: 0,
            averageAppStoreCrashFreeSessions: 0,
            averageAppStoreCrashFreeUsers: 0,
            averageBetaCrashFreeSessions: 0,
            averageBetaCrashFreeUsers: 0,
        },
        isStaticReleaseBranch: false,
        canBeSubmitted: true,
        shouldWarnAboutNewerCommits: false,
        shouldMatchPreviousPhasedRelease: false,
        destinationSummaries: [],
    };
    return release;
};

export const fillStepsWithReleaseData = (
    steps: ReleaseStep[],
    release: RecursiveStringifyEnums<Release>,
    appPlatform: AppPlatform,
) => {
    // add release data to each step so all steps have the massaged data from release
    steps.forEach((step) => {
        step.data = {
            ...step.data,
            ...release,
        };

        if (step.type === ReleaseStepType.FeatureReadiness) {
            const kickoffData = steps.find((step) => step.type === ReleaseStepType.Kickoff)
                ?.data as ReleaseStepKickoffData;

            step.data = syncFeatureAffiliationsDataWithFeatureStepData(
                kickoffData.resolvedFeatureAffiliations[0],
                step.data as ReleaseStepFeatureReadinessData,
                release,
                appPlatform,
                kickoffData.releaseBranch,
                kickoffData.workingBranch ?? '',
            );
        }
    });

    // sync step data
    return steps;
};
